import {Component, Input, Output, EventEmitter} from "@angular/core";

@Component({
  selector: 'widget-select',
  template: `<div
                [formGroup]="form"
                [class.has-error]="form.controls[id].touched && !form.controls[id].valid"
                [class.has-feedback]="form.controls[id].touched && !form.controls[id].valid">
                <label class="control-label text-right {{labelClass}}" for="{{id}}" [class.active]="model">{{ txtLabel | translate }}</label>
                <div class="{{containerInputClass}}">
                  
                  <span *ngIf="arraySimples">
                    <select id="{{id}}" class="form-control validate"
                          [(ngModel)]="model"
                          formControlName="{{id}}"
                          (change)="update($event.target.value)"
                          [class.input-view]="readonly">
                    <option [value]="listagemValueSelecione" selected *ngIf="listagemTxtSelecione">{{ 'front.selecione' | translate }}</option>
                    <option [value]="item" *ngFor="let item of listagem">{{item}}</option>
                  </select>
                  </span>
                  
                  <span *ngIf="!arraySimples">
                    <select id="{{id}}" class="form-control validate"
                          [(ngModel)]="model"
                          formControlName="{{id}}"
                          (change)="update($event.target.value)"
                          [class.input-view]="readonly">
                    <option [value]="listagemValueSelecione" selected *ngIf="listagemTxtSelecione">{{ 'front.selecione' | translate }}</option>
                    <option [value]="item[listagemValue]" *ngFor="let item of listagem">{{item[listagemTxt]}}</option>
                  </select>
                  </span>
                  
                  <div class="form-control-feedback" *ngIf="form.controls[id].touched && !form.controls[id].valid">
                    <i class="icon-cancel-circle2"></i>
                  </div>

                  <ng-template [ngIf]="form.controls[id].errors">
                    <span class="help-block" *ngIf="form.controls[id].touched && !form.controls[id].valid && !form.controls[id].errors[id]">{{txt_default_erro}}</span>
                    <div *ngIf="!form.controls[id].valid">
                      <span class="help-block" *ngFor="let erro of form.controls[id].errors[id] | keysBack">{{ 'back.'+erro.key | translate:erro.replace }}</span>
                    </div>
                  </ng-template>
                  
                </div>
              </div>`,
})

export class WidgetSelectComponent {
  @Input()
  id: string = '';

  @Input()
  model: any = '';

  @Output() modelChange = new EventEmitter<string>();

  @Input()
  form: any;

  @Input()
  listagem: any;

  @Input()
  listagemValue: any;

  @Input()
  listagemTxt: any;

  @Input()
  listagemTxtSelecione: boolean = true;

  @Input()
  listagemValueSelecione: any = '';

  @Input()
  txt_default_erro: any;

  @Input()
  txtLabel: string = '';

  @Input()
  labelClass: string = 'col-sm-2';

  @Input()
  containerInputClass: string = 'col-sm-10';

  @Input()
  readonly: boolean = false;

  @Input()
  arraySimples: boolean = false;

  update(val : string) {
    if (val === 'null' || val === 'undefined' || val === '') {
      this.model = null;
    } else {
      this.model = val;
    }
    console.log(val);
    console.log(this.id);
    console.log(this.form.controls);
    this.modelChange.emit(this.model);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/form/widget-select.component.ts